(function(){


  function uniqueByColor(arr){
  if (!arr || !arr.length) return null;

  const seen = new Set();
  const out = [];

  for (const it of arr){
    const color = norm(it?.c);
    if (!color) continue;      
    if (!it?.u) continue;

    if (seen.has(color)) continue;
    seen.add(color);
    out.push(it);
  }

  return out.length ? out : null;
}


  function getUserSeed(){
    const k = "inkd_rand_seed_v1";
    let s = localStorage.getItem(k);
    if (!s){
      s = String(Math.floor(Math.random() * 1e9));
      localStorage.setItem(k, s);
    }
    return s;
  }
  const USER_SEED = getUserSeed();

  function hash32(str){
    let h = 2166136261;
    for (let i=0; i<str.length; i++){
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  const mediaCache = new WeakMap();
  const elCache = new WeakMap();

  function norm(s){ return (s||"").toString().trim().toLowerCase(); }

  function getActiveColors(card){
    const raw = card.getAttribute('data-inkd-active-colors') || '';
    const list = raw.split('||').map(s => (s||'').trim()).filter(Boolean);
    return list;
  }

  function getMediaArr(card){
    let arr = mediaCache.get(card);
    if (arr !== undefined) return arr;

    const raw = card.getAttribute('data-inkd-variant-media');
    if (!raw) { mediaCache.set(card, null); return null; }

    try { arr = JSON.parse(raw); } catch { arr = null; }
    if (!Array.isArray(arr) || arr.length < 1) arr = null;

    mediaCache.set(card, arr);
    return arr;
  }

  function getCardEls(card){
    let c = elCache.get(card);
    if (c) return c;

    const img =
      card.querySelector('[data-inkd-primary-img]') ||
      card.querySelector('.product-grid-item__thumbnail .media img') ||
      card.querySelector('.product-grid-item__thumbnail img') ||
      card.querySelector('img');

    const link =
      card.querySelector('a.product__card--link') ||
      card.querySelector('a[href*="/products/"]');

    const pid =
      card.getAttribute('data-product-id') ||
      card.closest('[data-product-id]')?.getAttribute('data-product-id') ||
      '';

    c = { img, link, pid };
    elCache.set(card, c);
    return c;
  }

  function setImg(img, url){
    if (!img || !url) return;

    if (img.dataset.inkdSrcSetCleared !== "1"){
      const picture = img.closest('picture');
      if (picture){
        picture.querySelectorAll('source').forEach(s=>{
          if (s.srcset) s.srcset = '';
          if (s.dataset?.srcset) s.dataset.srcset = '';
        });
      }
      if (img.srcset) img.srcset = '';
      if (img.dataset?.srcset) img.dataset.srcset = '';
      img.dataset.inkdSrcSetCleared = "1";
    }

    if (img.dataset){
      if (img.dataset.src) img.dataset.src = url;
      if (img.dataset.originalSrc) img.dataset.originalSrc = url;
      if (img.dataset.master) img.dataset.master = url;
    }
    img.loading = img.loading || "lazy";
    img.decoding = img.decoding || "async";
    img.src = url;
  }

  function setVariantOnLink(link, vid){
    if (!link || !vid) return;
    const href = link.getAttribute('href') || '';
    if (!href) return;

    if (href.includes('?')){
      if (href.includes('variant=')){
        link.setAttribute('href', href.replace(/([?&])variant=[^&]*/,'$1variant='+encodeURIComponent(vid)));
      } else {
        link.setAttribute('href', href + '&variant=' + encodeURIComponent(vid));
      }
    } else {
      link.setAttribute('href', href + '?variant=' + encodeURIComponent(vid));
    }
  }

  function pickByActiveColor(arr, activeColors){
    if (!arr || !arr.length) return null;
    if (!activeColors || !activeColors.length) return null;

    const want = activeColors.map(norm).filter(Boolean);
    if (!want.length) return null;

    for (const w of want){
      const hit = arr.find(it => norm(it?.c) === w && it?.u);
      if (hit) return hit;
    }
    return null;
  }

  function pickRandom(arr, pid){
    if (!arr || !arr.length) return null;
    const idx = hash32(USER_SEED + ':' + pid) % arr.length;
    const choice = arr[idx];
    return (choice && choice.u) ? choice : null;
  }

function applyForCard(card){
  const arr = getMediaArr(card);
  if (!arr) return;

  const { img, link, pid } = getCardEls(card);
  if (!pid || !img) return;

  const activeColors = getActiveColors(card);

  const forced = pickByActiveColor(arr, activeColors);
  if (forced){
    setImg(img, forced.u);
    if (forced.vid) setVariantOnLink(link, forced.vid);

    card.dataset.inkdRandomApplied = "0";
    card.dataset.inkdForcedColorApplied = "1";
    return;
  }

  if (card.dataset.inkdRandomApplied === "1") return;

  const colorPool = uniqueByColor(arr) || arr;
  const choice = pickRandom(colorPool, pid);
  if (!choice) return;

  setImg(img, choice.u);
  if (choice.vid) setVariantOnLink(link, choice.vid);

  card.dataset.inkdRandomApplied = "1";
  card.dataset.inkdForcedColorApplied = "0";
}

  function applyAll(){
    const cards = document.querySelectorAll('.product-grid-item[data-inkd-variant-media]');
    for (let i=0; i<cards.length; i++){
      applyForCard(cards[i]);
    }
  }

  let scheduled = false;
  function scheduleApply(){
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      applyAll();
    });
  }

  function boot(){
    scheduleApply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once:true });
  } else {
    boot();
  }

  document.addEventListener("inkd:collection:swapped", boot);

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations){
      for (const n of m.addedNodes){
        if (!(n instanceof Element)) continue;
        if (n.matches?.('.product-grid-item[data-inkd-variant-media]') ||
            n.querySelector?.('.product-grid-item[data-inkd-variant-media]')) {
          scheduleApply();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  let lastHref = location.href;
  setInterval(() => {
    if (location.href !== lastHref){
      lastHref = location.href;
      scheduleApply();
    }
  }, 300);
})();
